import { Box, Grid, Skeleton } from '@mui/material'


const StoreTabSkeleton = () => {
    return (
        <div className='mt-8 px-5 overflow-y-auto h-[calc(100vh-120px)]' >
            {[...Array(4)].map((_, index) => (
                <Box key={index} sx={{ marginBottom: "20px" }}>
                    <Skeleton variant='rectangular' height={15} width={150} sx={{ borderRadius: "8px" }} />
                    <Box sx={{ display: "flex", gap: "10px", marginTop: "10px", padding: "10px", overflowX: "auto", flexWrap: "nowrap" }}>
                        {[...Array(5)].map((_, index) => (
                            <Grid key={index} container gap={"5px"} xs={4} flexDirection={"column"} sx={{ justifyContent: 'center', minWidth: "100px", alignItems: "center" }}>
                                <Grid item>
                                    <Skeleton variant='rectangular' width={75} height={75} sx={{ borderRadius: "25px" }} />
                                </Grid>
                                <Grid item>
                                    <Skeleton variant='rectangular' height={10} width={60} sx={{ borderRadius: "8px" }} />
                                </Grid>
                            </Grid>
                        ))}
                    </Box>
                </Box>
            ))}
        </div>
    )
}

export default StoreTabSkeleton